import { dateTime, timeOfDay, utcIso } from '../format';

/**
 * A time as a person reads it: Thai local time (`dd/MM/yyyy HH:mm:ss`, or the clock only),
 * with the exact UTC instant as the tooltip and in `datetime` (UX review P2-7).
 */
export function When({ iso, clock = false, testid }: { iso: string | null | undefined; clock?: boolean; testid?: string }) {
  const utc = utcIso(iso);
  const text = clock ? timeOfDay(iso) : dateTime(iso);
  if (!utc) return <span data-testid={testid}>{text}</span>;
  return (
    <time className="nowrap" dateTime={utc} title={utc} data-testid={testid}>
      {text}
    </time>
  );
}
